<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <vx-card>
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mt-5">
          <h6 class="mb-2">Cliente</h6>
          <v-select
              name="customer"
              v-model="customerSelected"
              :options="getCustomersFiltered"
              :loading="isLoadingCustomers"
              :filterable="true"
              :searchable="true"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-validate="'required'"
              placeholder="Digite para buscar (min. 2 caracteres)..."
              @search="onSearchCustomers"
              :no-drop="searchTerm.length > 0 && searchTerm.length < 2"
              :close-on-select="true"
            >
              <template slot="no-options">
                <span v-if="searchTerm.length > 0 && searchTerm.length < 2">
                  Digite pelo menos 2 caracteres
                </span>
                <span v-else-if="isLoadingCustomers">
                  Carregando...
                </span>
                <span v-else>
                  Nenhum cliente encontrado
                </span>
              </template>
              </v-select>
          <br />
          <span class="text-danger">{{ errors.first("customer") }}</span>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-1/3 mt-5">
          <h6 class="mb-2">E-mail</h6>
          <vs-input
            name="recipient1"
            v-model="customerSelected.mail"
            class="w-full"
            v-validate="'required'"
          />
          <br />
          <span class="text-danger">{{ errors.first("recipient1") }}</span>
        </div>
        <div class="vx-col md:w-1/3 w-1/3 mt-5">
          <h6 class="mb-2">E-mail</h6>
          <vs-input
            name="recipient2"
            v-model="customerSelected.mail2"
            class="w-full"
          />
          <br />
        </div>
        <div class="vx-col md:w-1/3 w-1/3 mt-5">
          <h6 class="mb-2">Template</h6>
          <v-select
            name="template"
            v-model="templateSelected"
            :options="templates"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-validate="'required'"
          />
          <br />
          <span class="text-danger">{{ errors.first("template") }}</span>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col mt-5">
          <input
            multiple
            type="file"
            class="hidden"
            ref="attachmentInput"
            @change="attachFile()"
            accept="application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            name="file"
          />
          <!--    accept="application/pdf, image/*, vnd.openxmlformats-officedocument.spreadsheetml.sheet "-->
          <vs-button color="primary" @click="$refs.attachmentInput.click()">
            Selecione os arquivos
          </vs-button>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-full mt-5">
          <vs-list :key="indextr" v-for="(item, indextr) in items">
            <vs-list-item
              :title="item.name"
              :subtitle="item.type"
            ></vs-list-item>
          </vs-list>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-full mt-5" v-if="showSaveButton">
          <vs-button class="float-right" color="success" @click="submit"
            >Salvar</vs-button
          >
          <vs-button class="float-left" color="warning" @click="clean"
            >Limpar</vs-button
          >
        </div>
      </div>
    </vx-card>
  </div>
</template>


<script>
import { Validator } from "vee-validate";
import { fileTools } from "@/helpers";
import axios from "axios";
import { baseApiUrl } from "@/global";
import router from "@/router";
import vSelect from "vue-select";
const dict = {
  custom: {
    recipient1: {
      required: "Digite o e-mail",
    },
    template: {
      required: "Selecione o Template",
    },
    customer: {
      required: "Selecione o Cliente",
    },
  },
};

Validator.localize("en", dict);
export default {
  components: {
    "v-select": vSelect,
  },
  data() {
    return {
      customerSelected: [],
      currentAttachment: {},
      showSaveButton: false,
      fileTools: null,
      // recipient1: null,
      //recipient2: null,
      items: [],
      templateSelected: null,
      templates: ["Locação", "Ouro", "Suprimentos", "Mão de Obra"],
      searchTerm: '',
      maxResults: 50,
      minSearchLength: 2,
    };
  },
  computed: {
    getCustomersFiltered() {
      return this.$store.state.customers.customersFiltered || []
    },
    
    // Novo computed para verificar loading
    isLoadingCustomers() {
      return this.$store.state.customers.isLoading
    },
    
    /* getCustomersFiltered() {
      let customers = _.cloneDeep(this.$store.state.customers.customersFiltered);
       customers.forEach((element) => {
        element.id = element.id;
        element.label = `${element.idIlux} | ${element.corporateName}`;
        element.mail = element.mail;
        element.mail2 = element.mail2;
      });
      return customers;
    }, */
  },
  methods: {
      // Método debounced para busca otimizada
      onSearchCustomers: _.debounce(async function(search) {
      this.searchTerm = search || ''
      
      try {
        await this.$store.dispatch('customers/searchCustomers', {
          searchTerm: this.searchTerm,
          limit: this.maxResults
        })
      } catch (error) {
        console.error('Erro na busca de clientes:', error)
        this.$vs.notify({
          title: 'Erro',
          text: 'Erro ao buscar clientes. Tentando busca local...',
          color: 'warning'
        })
      }
    }, 300),

    // Método para pré-carregar dados essenciais
    async preloadCustomersData() {
      try {
        const payload = {
          loading: this.$vs.loading,
          idOrder: null,
          typeOrder: this.endpointType,
          idCustomer: this.customerSelected.id,
        }
        
        // Carregar todos os clientes uma vez
        await this.$store.dispatch("customers/fetchCustomersItems", payload)
        
        // Aplicar busca inicial vazia para mostrar primeiros resultados
        await this.$store.dispatch('customers/searchCustomers', {
          searchTerm: '',
          limit: this.maxResults
        })
        
      } catch (error) {
        console.error('Erro ao pré-carregar clientes:', error)
        this.$vs.notify({
          title: 'Aviso',
          text: 'Erro ao carregar lista de clientes',
          color: 'warning'
        })
      }
    },
    async submit() {
      const haveErrors = !(await this.$validator.validateAll());
      if (haveErrors) return;
      let data = {
        fk_idCustomer: this.customerSelected.id,
        recipient1: this.customerSelected.mail,
        recipient2: this.customerSelected.mail2,
        items: this.items,
        template: this.templateSelected,
      };
      if(data.fk_idCustomer == null || data.fk_idCustomer == undefined) {
        this.$vs.notify({
          title: "Atenção",
          text: "Selecione um cliente",
          color: "warning",
        });
        return;
      }
      try {
        this.$vs.loading();
        await axios.post(`${baseApiUrl}/invoice/upload`, data);
        this.$vs.notify({
          title: "Salvo",
          text: "com Sucesso",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        });
        router.push("/faturas").catch(() => {});
     } catch (error) {
        if (!error.response || !error.response.data) return;
        this.$vs.notify({
          title: "Ocorreu algum problema",
          text: error.response.data,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
      } finally {
        this.$vs.loading.close();
        this.items = [];
      }
    },

    async attachFile() {
      this.showSaveButton = true;
      for (const element of this.$refs.attachmentInput.files) {
        let base64 = await this.fileTools.toBase64(element);
        let fileName = element.name;
        let type = element.type;
        let item = {
          name: fileName.toUpperCase(),
          file: base64,
          type: type,
        };
        this.items.push(item);
      }
    },
    async clean() {
      this.items = [];
      this.showSaveButton = false;
    },
  },
  async created() {
    this.fileTools = fileTools();
    await this.preloadCustomersData()
    let payload = {
      loading: this.$vs.loading,
    };
    
    // Limpar cache expirado periodicamente
    setInterval(() => {
      this.$store.dispatch('customers/clearExpiredCache')
    }, 1 * 60 * 1000) // A cada 5 minutos
  },
   // Limpar intervalos ao destruir componente
   beforeDestroy() {
    // Limpar qualquer timer se necessário
  }
};
</script>

<style scoped>
/* Estilos para melhorar a performance visual */
.vs__dropdown-toggle {
  transition: border-color 0.15s ease-in-out;
}

.vs__dropdown-toggle:focus-within { 
  border-color: #3b82f6;
  box-shadow: 0 0 0 1px #3b82f6;
}

/* Otimizar scroll do dropdown */
.vs__dropdown-menu {
  max-height: 200px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

/* Loading state */
.vs__open-indicator {
  transition: transform 0.15s ease;
}
</style>

 
